module.exports = __webpack_public_path__ + "r-v3/img/menu_waiting_white.12f2ffc8.svg";